const bunnings = {
    tagUrl: "//pf-track.inside-graph.com/gtm/IN-1000964/include.js",
    logo: "/assets/bunnings-logo.svg",
    customCss: () => {
        var css = ".header {padding: 0; height: 80px; background: #0D5257} .subheader {background: #0D5257}";
        var style = document.createElement("style");
        style.appendChild(document.createTextNode(css));
        document.head.appendChild(style);
    },
}

export default bunnings;